import React from "react";

const Java_Void = () => {
  return (
    <div>
      <h1>Java Void</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Void in Java.</p>
    </div>
  );
};

export default Java_Void;
